import { useState, useRef } from "react";
import { Row, Drawer, Button } from "rsuite";
import Hls from "hls.js";
import EyeRoundIcon from "@rsuite/icons/EyeRound";

function HlsDrawerPlayer({ src }) {
  const [open, setOpen] = useState(false);
  const videoRef = useRef(null);

  const initHls = () => {
    if (videoRef.current) {
      if (Hls.isSupported()) {
        const hls = new Hls();
        hls.loadSource(src);
        hls.attachMedia(videoRef.current);

        hls.on(Hls.Events.MANIFEST_PARSED, () => {
          videoRef.current.muted = true; // required for autoplay
          videoRef.current.play();
        });
      } else if (
        videoRef.current.canPlayType("application/vnd.apple.mpegurl")
      ) {
        // Safari/iOS native HLS
        videoRef.current.src = src;
      }
    }
  };

  return (
    <>
      <Row
        display="flex"
        justifyContent="flex-end"
        alignItems="center"
        paddingRight={"10px"}
        onClick={() => setOpen(true)}
      >
        <Button startIcon={<EyeRoundIcon />} appearance="primary" size="sm">
          Live Stream
        </Button>
      </Row>

      <Drawer
        size="70%"
        placement="right"
        open={open}
        onClose={() => setOpen(false)}
        onEntered={initHls} // initialize HLS only after drawer animation completes
      >
        <Drawer.Header>
          <Drawer.Title>Live Stream</Drawer.Title>
        </Drawer.Header>
        <Drawer.Body style={{ backgroundColor: "#181818", color: "white" }}>
          {/* Fixed-size container prevents resize thrashing */}
          <div
            style={{
              backgroundColor: "#181818",
              width: "100%",
              height: "500px",
            }}
          >
            SSTD Camera 01 (Live)
            <video
              ref={videoRef}
              controls
              playsInline
              muted
              style={{
                width: "100%",
                height: "100%",
                display: "block",
                border: "1px solid #494949",
              }}
            />
          </div>
        </Drawer.Body>
      </Drawer>
    </>
  );
}

export default HlsDrawerPlayer;
